import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getMessages = (payload) =>
  httpClient.get(apis.GET_MESSAGES, {
    params: payload,
  });
export const readMessage = (payload) =>
  httpClient.post(apis.READ_MESSAGE, payload, { ignore: true });
export const readAllMessage = () => httpClient.get(apis.READ_ALL_MESSAGE, null, { ignore: true });

export const getIMToken = () => httpClient.get(apis.GET_IM_TOKEN);
